import React from 'react';

import { ICartRequestIconProps } from './CartRequestIcon.types';

import './CartRequestIcon.scss';

const CartRequestIcon = ({
	icon,
	counter,
}: ICartRequestIconProps) => {
	const isCounterShown = counter > 0;

	return (
		<div className='f5gCartRequestIcon'>
			{icon}
			{isCounterShown
				&& <div className='f5gCartRequestIconCounter'>
					{counter}
				</div>
			}
		</div>
	);
};

export default CartRequestIcon;
